import { CommonSearchParam, ApiBind } from './common-search-param.model';

export class OSSearchParam extends CommonSearchParam {

  constructor(
    name?: string,
    value?: string,
  ) {
    super();
    this.name = name;
    this.value = value;
  }

  @ApiBind({ column: 'name' })
  name: string;

  @ApiBind({ column: 'value' })
  value: string;

}
